const Header = ({ firstName, lastName, university, img }: { firstName?: string; lastName?: string; university?: string; img?: string; }) => {
    return (
        <div className="md:mt-20 mt-7 relative text-burntBlack">
            <div className="mx-1.5 bg-primary px-5 sm:px-[52px] sm:pt-9 pt-5 rounded-lg sm:rounded-[36px] bg-no-repeat bg-cover bg-center bg-heroBg w-full text-white sm:h-[280px] h-[120px] relative sm:mb-24 mb-20">
                <h1 className="font-bold text-lg sm:text-4xl md:text-5xl leading-tight mb-3 text-[#94D6FC] sm:max-w-[475px] max-w-[178px]">Ready to build your
                    Partnership <span className="text-white">with us! </span> </h1>
                <div className="border-[10px] w-fit rounded-full overflow-hidden border-white absolute md:bottom-auto sm:-bottom-20">
                    <img src={img} alt="Instructor" className="sm:size-[180px] size-[90px] object-cover rounded-full " />
                </div>

            </div>
            <div className="sm:ml-[76px] ml-7">
                <h1 className="sm:text-[38px] text-lg font-bold sm:mt-9 mt-5 pt-0.5 sm:mb-4 mb-2">Dr. {firstName} {lastName}</h1>
                <div className="flex sm:gap-5 gap-1.5 items-center mb-3">
                    <p className="sm:text-2xl  font-medium text-lightGray">Instructor</p>
                    <span className="sm:size-2.5 size-1.5 bg-lightGray rounded-full"></span>
                    <p className="sm:text-2xl  font-medium text-lightGray">{university}</p>
                </div>
                {/* <div className="flex gap-2.5 items-center">
                    <div className="px-[22px] py-2 bg-[#EFF9FF] border-primary/10 border rounded-[36px] text-base text-primary font-medium w-fit">Career path</div>
                    <div className="px-[22px] py-2 bg-[#FFF9E5] border-[#FACB2C]/10 border rounded-[36px] text-base text-[#FACB2C] font-medium w-fit">Career path</div>
                </div> */}
            </div>

        </div>
    )
}

export default Header